import React from 'react'
import queryString from 'query-string'
import { useQuery, QueryCache, ReactQueryCacheProvider } from 'react-query'
import { LoadingOutlined } from '@ant-design/icons'
import { ReactQueryDevtools } from 'react-query-devtools'
import styled from 'styled-components'

import Layout from '../components/layout'
import NotFound from './404'
import SEO from '../components/seo'
import QuizPage from '../components/quiz'

const queryCache = new QueryCache()

const ErrorPage = styled.div`
  display: flex;
  height: 100vh;
  justify-content: center;
  align-items: center;
  flex-direction: column;
`

const ErrorWrapper = styled.div`
  display: flex;
  justify-content: center;
  flex-direction: column;
  align-items: center;
  background-color: white;
  padding: 40px;
  border-radius: 5px;
`

const IndexPage = ({ quizId, installType, draft }) => {
  const { isLoading, error, data } = useQuery('quiz', async () => {
    let url = `${process.env.GATSBY_API_URL}/quiz?id=${quizId}`
    if (draft) {
      url += '&draft=1'
    }
    const res = await fetch(url)
    return res.json()
  })

  if (isLoading) {
    return <LoadingOutlined />
  }

  if (error) {
    console.error(error)
    return <div></div>
  }

  if (data.message) {
    console.error(data.message)
    if (data.message === 'NO PLAN')
      return (
        <ErrorPage>
          <ErrorWrapper>
            <h2>No Prehook Plan Selected</h2>
            <p>
              Please activate your membership plan from your Prehook dashboard!
            </p>
          </ErrorWrapper>
        </ErrorPage>
      )
    if (data.message === 'ENGAGEMENTS EXCEEDED - UPGRADE PLAN') {
      return (
        <ErrorPage>
          <ErrorWrapper>
            <h2>Engagement Limit Reached!</h2>
            <p>Upgrade your Plan on the Prehook Dashboard.</p>
          </ErrorWrapper>
        </ErrorPage>
      )
    }
    return (
      <ErrorPage>
        <ErrorWrapper>
          <h1>Quiz Unavailable</h1>
          <p>Contact Support</p>
          <a href="mailto://support@prehook.com">support@prehook.com</a>
        </ErrorWrapper>
      </ErrorPage>
    )
  }

  const quiz = data.data

  if (data.statusCode === 404) {
    return <NotFound />
  }
  const installSettings = quiz?.installSettings
  const settings = installSettings?.[installType]
  return (
    <Layout settings={settings} theme={quiz.theme}>
      <SEO title="Quiz Builder" />
      <QuizPage installType={installType} draft={draft} />
    </Layout>
  )
}

const App = ({ location }) => {
  const query = queryString.parse(location.search)
  const quizId = query?.id
  const draft = query?.draft
  const shopifyNavLink = query?.navlink
  const buttonLink = query?.buttonlink
  const autoPopup = query?.popup

  if (!quizId) {
    return <LoadingOutlined />
  }

  let installType = ''
  if (shopifyNavLink === 'true') {
    installType = 'link'
  }
  if (buttonLink === 'true') {
    installType = 'button'
  }
  if (autoPopup === 'true') {
    installType = 'automatic'
  }

  return (
    <ReactQueryCacheProvider queryCache={queryCache}>
      <ReactQueryDevtools initialIsOpen={false} />
      <IndexPage quizId={quizId} installType={installType} draft={draft} />
    </ReactQueryCacheProvider>
  )
}

export default App
